import { User } from 'lib-shared-types-api';
import { getHighestUserRole } from 'lib-shared-user-role';
import { createSelector } from 'reselect';

import { AppState } from 'bootstrap.store';

import type { UserModalState } from './userModal.reducer';
import type { UserModalFormData } from './userModal.types';

export function selectUserModal(state: AppState): UserModalState {
  return state.userModal;
}

export function selectUserModalUser(state: AppState): User | null {
  return selectUserModal(state).user;
}

export const selectUserModalInitialValues = createSelector(
  selectUserModalUser,
  (user) => {
    if (!user) return {};

    const initialValues: UserModalFormData = {
      ...user,
      emails: user.email
        ? [
            { value: user.email },
            ...(user.additional_emails?.map((value) => ({ value })) ?? []),
          ]
        : [{ value: '' }],
      phone_numbers: user.phone_number
        ? [
            { value: user.phone_number },
            ...(user.additional_phone_numbers?.map((value) => ({ value })) ??
              []),
          ]
        : [{ value: '' }],
    };

    if (user.roles) {
      initialValues.role = getHighestUserRole(user.roles);
    }

    return initialValues;
  },
);
